export default function percentage(number) {
  return parseInt(number) + "%";
}
